<template>
  <section class="sportFootballMatch">
    <section>
      <span v-show="match && !autorized" class="notAllowed">Match non autorisé</span>
      <header-page v-show="autorized" :match="match"/>
      <section>
        <team v-show="autorized" :match="matchData" :team-id="teamHomeId" />
        <section>
          <status v-show="autorized" :match="matchData" @statusfilter="setStatusFilter"/>
          <actions v-show="autorized" v-if="actionTypeReady" :match="matchData" :statusFilter="statusFilter"/>
        </section>
        <team v-show="autorized" :match="matchData" :team-id="teamAwayId" />
      </section>
    </section>
  </section>
</template>

<script>
import Actions from '@/components/sport/football/match/Actions'
import HeaderPage from '@/components/sport/football/match/Header'
import Team from '@/components/sport/football/match/Team'
import Status from '@/components/sport/football/match/Status'

export default {
  name: 'SportFootballMatch',
  components: { Actions, HeaderPage, Team, Status },
  data () {
    return {
      statusFilter: null,
      competitionError: String
    }
  },
  computed: {
    matchId () { return this.$route.params.matchId ? parseInt(this.$route.params.matchId) : null },
    match () { return this.$store.getters['Sport/Football/Match/match'](this.matchId) },
    autorized () { return this.match?.competitionSeason.actionRealTime },
    matchData () { return this.autorized ? this.match : null },
    teamHomeId () { return this.match?.teamHomeId },
    teamAwayId () { return this.match?.teamAwayId },
    actionTypeReady () {
      return this.$store.getters['Sport/Football/Action/Destination/list']?.length > 0 &&
        this.$store.getters['Sport/Football/Action/Detail1/list']?.length > 0 &&
        this.$store.getters['Sport/Football/Action/Origin/list']?.length > 0
    }
  },
  created () {
    this.$store.dispatch('Sport/Football/Action/Destination/init')
    this.$store.dispatch('Sport/Football/Action/Detail1/init')
    this.$store.dispatch('Sport/Football/Action/Origin/init')
    this.$store.dispatch('Sport/Football/Match/init', this.matchId)
    this.$store.dispatch('Server/page', this.$route.path)
  },
  methods: {
    setStatusFilter (value) { this.statusFilter = value }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed');
body{
  height:100%;
  --color-primary:#3a8ee6;
  --color-team-home: #2892d7;
  --color-team-away: #6CD264;
  --color-font-black: black;
  --color-font-grey: #909399;
  --color-font-grey-light: #bfc0c4;
  --color-font-live: #6cd264;
  --color-font-offset: #FBA21C;
  --color-background-grey: #eee;
  --color-background-grey-dark: #d8d8d8;
  --color-background-live: #e5ffe8;
  --color-background-offset: #ffeccf;
  --color-background-offset-dark: #FBA21C;
  --color-border-grey: #dcdfe6;
  --color-border-grey-dark: #c0c4cc;
  --color-error: red;
  --color-error-warning: blue;
  --color-error-no: green;
  font-family:'Oswald',sans-serif
}
.sportFootballMatch{
  position:fixed;
  display:block;
  width: 100%;
  height: 100%;
}
.sportFootballMatch > section{
  display:inline-block;
  width:100%;
  height:100%;
  overflow:hidden;
  transition:0.5s
}
.sportFootballMatch > section > section{
  position:relative;
  display:flex;
  width:100%;
  height: calc(100% - 70px);
}
.sportFootballMatch > section > section > section{
    flex: 1 1 auto;
    height: 100%;
    display:flex;
    flex-direction: column;
}
.sportFootballMatch .notAllowed{
  position:fixed;
  width:300px;
  left:50%;
  margin-left:-150px;
  height:60px;
  top:50%;
  margin-top:-30px;
  line-height:60px;
  background-color:white;
  font-size:20px;
  font-weight:bold;
  border-radius:10px;
  text-align:center;
}
</style>
